var map = {
	"./embrapa-white.png": "955a",
	"./embrapa.png": "48ab",
	"./icons/android-chrome-192x192.png": "296d",
	"./icons/android-chrome-512x512.png": "c2a2",
	"./icons/apple-touch-icon.png": "7219",
	"./icons/favicon-16x16.png": "2713",
	"./icons/favicon-32x32.png": "e9ae",
	"./icons/icon-128x128.png": "792b",
	"./icons/icon-144x144.png": "f257",
	"./icons/icon-152x152.png": "2a16",
	"./icons/icon-192x192.png": "e810",
	"./icons/icon-384x384.png": "423d",
	"./icons/icon-512x512.png": "f0bc",
	"./icons/icon-72x72.png": "b48c",
	"./icons/icon-96x96.png": "4b44",
	"./icons/mstile-150x150.png": "d5ef",
	"./ios.png": "c127",
	"./logo.png": "4ffd",
	"./partners-white-landscape.png": "21f9",
	"./partners-white.png": "3716",
	"./partners.png": "81af",
	"./pasture_andropogon_high.jpg": "2320",
	"./pasture_andropogon_high.webp": "d727",
	"./pasture_andropogon_low.jpg": "5b1f",
	"./pasture_andropogon_low.webp": "ac63",
	"./pasture_andropogon_middle.jpg": "aab0",
	"./pasture_andropogon_middle.webp": "44d5",
	"./pasture_brachiaria_high.jpg": "e01e",
	"./pasture_brachiaria_high.webp": "6ca4",
	"./pasture_brachiaria_low.jpg": "5fd1",
	"./pasture_brachiaria_low.webp": "61c9",
	"./pasture_brachiaria_middle.jpg": "5b37",
	"./pasture_brachiaria_middle.webp": "e513",
	"./pasture_buffel.jpg": "3935",
	"./pasture_buffel.webp": "2506",
	"./pasture_buffel_high.jpg": "9dca",
	"./pasture_buffel_high.webp": "8c93",
	"./pasture_buffel_low.jpg": "98f6",
	"./pasture_buffel_low.webp": "202d",
	"./pasture_buffel_middle.jpg": "e28d",
	"./pasture_buffel_middle.webp": "29d7",
	"./pasture_cynodon_high.jpg": "52c8",
	"./pasture_cynodon_high.webp": "4117",
	"./pasture_cynodon_low.jpg": "bdb5",
	"./pasture_cynodon_low.webp": "51f7",
	"./pasture_cynodon_middle.jpg": "f5e6",
	"./pasture_cynodon_middle.webp": "5042",
	"./pasture_high.jpg": "ba09",
	"./pasture_high.webp": "aee3",
	"./pasture_low.jpg": "76c9",
	"./pasture_low.webp": "ba23",
	"./pasture_middle.jpg": "7808",
	"./pasture_middle.webp": "2966",
	"./pasture_natural_high.jpg": "c9eb",
	"./pasture_natural_high.webp": "a8f3",
	"./pasture_natural_low.jpg": "bf2f",
	"./pasture_natural_low.webp": "93a6",
	"./pasture_natural_middle.jpg": "20c5",
	"./pasture_natural_middle.webp": "4e7b",
	"./pasture_panicum_high.jpg": "3e8c",
	"./pasture_panicum_high.webp": "85d2",
	"./pasture_panicum_low.jpg": "9c51",
	"./pasture_panicum_low.webp": "7db6",
	"./pasture_panicum_middle.jpg": "1af1",
	"./pasture_panicum_middle.webp": "156d",
	"./stamp.png": "0763",
	"./stamp_partners.png": "7543",
	"./user.png": "0f71"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";